// extracted by mini-css-extract-plugin
module.exports = {"sameBillingAddress":"CPPolicyInformationPage_sameBillingAddress__1K0dV"};